/**
 * iwo 通知公告-新建公告弹窗
 * tanyaohua
 * 2020-12-22
 */
angular.module('iwoNoticeNewCreateModule', []).controller('iwoNoticeNewCreateCtrl', [
    '$scope',
    '$state',
    '$q',
    '$compile',
    '$element',
    'ueditorService',
    '$timeout',
    '$validation',
    'trsspliceString',
    'iwoNoticeService',
    'modalDialog',
    '$modalInstance',
    'params',
    'hasPublish',
    function(
        $scope,
        $state,
        $q,
        $compile,
        $element,
        ueditorService,
        $timeout,
        $validation,
        trsspliceString,
        iwoNoticeService,
        modalDialog,
        $modalInstance,
        params,
        hasPublish
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                noticeId: params ? params.noticeid : 0,
                editStatus: params ? params.status : '',
                support: {},
                fileType: [
                    'css',
                    'doc',
                    'docx',
                    'shtml',
                    'html',
                    'jpg',
                    'js',
                    'png',
                    'ppt',
                    'rar',
                    'txt',
                    'xls',
                    'xml',
                    'zip',
                    'xlsx',
                    'htm',
                    'pptx',
                    'bmp',
                    'exe',
                    'flv',
                    'gif',
                    'mp3',
                    'mr',
                    'pdf',
                    'swf',
                    'wav',
                ],
                token: '',
            };
            $scope.data = {
                noticeType: [],
                contribution: 0,
                hasPublish: hasPublish,
            };
            $scope.appendixUpload = { 
                options: {
                    maxSize: 300,
                    maxCount: 10,
                    isShowLabel: true,
                    labelName: '附件',
                    isShowAddIcon: true,
                    addButtonName: '添加',
                    uploadUrl: '/message/file/upload',
                    listStyle: 'table'
                },
                fileList: [],
            };
        }

        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            getNoticeTypeList()
                .then(() => $scope.status.noticeId == 0 ? initNewData() : initEditData())
                .then(() => {
                    loadDirective();
                });
        }

        /**
         * [initNewData description] 新建
         * @return {[type]} [description]
         */
        function initNewData() {
            $scope.wtt = '新建通知';
            let defer = $q.defer();
            $scope.list = {
                typeid: $scope.data.noticeType.length > 0 ? $scope.data.noticeType[0].typeid : -1,
                title: '',
                titlecolor: '',
                CONTENT: '',
                HTMLCONTENT: '',
                appendixinfo: [],
                groupids: '',
                userids: '',
                tenantids: '',
                alluser: true,
                dispatchunit: '',
                tenantuser: false,
            };
            $scope.data.selectedUsers = [];
            $scope.data.selectedDept = [];
            $scope.data.selectedGroup = [];
            $scope.data.publishDistributionType = 0;
            defer.resolve();
            return defer.promise;
        }

        /**
         * [initEditData description] 获取公告信息
         * @return {[type]} [description]
         */
        function initEditData() {
            let defer = $q.defer();
            $scope.wtt = '编辑通知';
            // $scope.status.token = $sessionStorage.cookie.get('userToken').token;
            let params = {
                noticeid: $scope.status.noticeId,
                // token: $scope.status.token,
            };
            iwoNoticeService.initEditData(params).then((data) => {
                if (data.issuccess == 'false') {
                    modalDialog.alertType('', data.msg, 'error', false);
                    defer.reject();
                } else {
                    $scope.list = {
                        typeid: -1,
                        title: data.data.title,
                        dispatchunit: data.data.dispatchunit,
                        titlecolor: data.data.titlecolor,
                        CONTENT: data.data.content,
                        HTMLCONTENT: data.data.content,
                        appendixinfo: data.data.appendixs.map((_item) => ({ FileSize: _item.filesize, FileName: _item.filename, FileDesc: _item.filedesc })),
                        groupids: data.data.groupids,
                        newgroupids: data.data.newgroupids,
                        userids: data.data.userids,
                        tenantids: data.data.tenantids,
                        alluser: data.data.alluser,
                        tenantuser: data.data.tenantuser,
                    };
                    typeFormat(data.data.typeid);
                    $scope.data.contribution = data.data.alluser ? 0 : 1;
                    if (angular.isDefined(data.data.groups) && data.data.groups.length > 0) {
                        $scope.data.publishDistributionType = 1;
                    } else if (angular.isDefined(data.data.newgroups) && data.data.newgroups.length > 0) {
                        $scope.data.publishDistributionType = 2;
                    } else {
                        $scope.data.publishDistributionType = 0;
                    }
                    if (!$scope.list.alluser) {
                        if ($scope.data.publishDistributionType === 0 && data.data.users) {
                            $scope.data.selectedUsers = data.data.users.map((_item) => ({ ID: _item.ID, DESC: _item.TRUENAME }));
                            $scope.selectedName = $scope.data.selectedUsers
                                .map((_item) => _item.DESC)
                                .join('、');
                        } else if ($scope.data.publishDistributionType == 1) {
                            $scope.data.selectedDept = data.data.groups.map((_item) => ({ GROUPID: _item.ID, GNAME: _item.GNAME }));
                            $scope.selectedName = $scope.data.selectedDept
                                .map((_item) => _item.GNAME)
                                .join('、');
                        } else {
                            $scope.data.selectedGroup = data.data.newgroups;
                            $scope.selectedName = $scope.data.selectedGroup
                                .map((_item) => _item.LABELNAME)
                                .join('、');
                        }
                    }
                    defer.resolve();
                }
            });
            return defer.promise;
        }

        /**
         * [getNoticeTypeList description] 获取公告类型
         * @return {[type]} [description]
         */
        function getNoticeTypeList() {
            let defer = $q.defer();
            iwoNoticeService.getNoticeTypeList().then((data) => {
                if (data.issuccess === 'false') {
                    modalDialog.alertType('', data.msg, 'error', false);
                    defer.reject();
                } else {
                    $scope.data.noticeType = [].concat(data.data);
                    defer.resolve();
                }
            });
            return defer.promise;
        }

        /**
         * [typeFormat description] 公告类型处理（如果选中的公告类型被停用，清空选中的公告类型）
         * @param  {[type]} typeId [description] 原来选中的公告类型ID
         * @return {[type]}        [description]
         */
        function typeFormat(typeId) {
            for (let i = 0; i < $scope.data.noticeType.length; i++) {
                if ($scope.data.noticeType[i].typeid == typeId) {
                    $scope.list.typeid = typeId;
                    return;
                }
            }
        }

        /**
         * [loadDirective description] 动态加载编辑器指令
         * @return {[type]} [description]
         */
        function loadDirective() {
            var defer = $q.defer();
            LazyLoad.js(['./lib/ueditor2/ueditor.config.js?v=11.5', './lib/ueditor2/ueditor.all.js?v=11.8'], function() {
                var ueditor = '<ueditor-for-notice has-content="status.hasContent"  list="list"></ueditor-for-notice>';
                ueditor = $compile(ueditor)($scope);
                $element.find('ueditorLocation').append(ueditor);
                $scope.status.support.content = $scope.list.CONTENT;
                var ue = UE.getEditor('ueditor');
                ue.ready(function() {
                    ue.addListener('keydown', function(type, event) {
                        if (event.keyCode === 13) {
                            // 获取纯文本
                            $scope.status.support.content = ue.getContentTxt();
                        }
                    });
                    $element.find('.publicModal .body_manuscript').scroll(function() {
                        var q = $element.find('.publicModal .body_manuscript').scrollTop();
                        var bodyH = $element.find('.publicModal .edui-editor-iframeholder').height();
                        var innerH = $element.find('.publicModal .body_manuscript').height();
                        if (q > 60) {
                            $('.edui-editor-toolbarbox').css('top', '60px');
                        } else if (q < 60) {
                            $('.edui-editor-toolbarbox').css('top', '160px');
                        }
                    });
                    defer.resolve();
                });
            });
            return defer.promise;
        }

        /**
         * [save description]保存
         * @return {[type]} [description]
         */
        function save() {
            let defer = $q.defer();
            ueditorService.saveContent($scope.list);
            if ($scope.list.typeid == -1) {
                modalDialog.alertType('', '请选择启用的通知类型', 'error', false);
                defer.reject();
                return defer.promise;
            }
            $timeout(function() {
                $scope.noticeForm.$pending = {};
                $validation
                    .validate($scope.noticeForm)
                    .success(function() {
                        $scope.list.appendixinfo = $scope.appendixUpload.fileList;
                        $scope.list.appendixinfo.map((item, index) => {
                            item.Order = index + 1;
                        });
                        let params = {
                            typeid: $scope.list.typeid,
                            title: $scope.list.title,
                            dispatchunit: $scope.list.dispatchunit,
                            titlecolor: $scope.list.titlecolor,
                            content: $scope.list.HTMLCONTENT,
                            appendixinfo: JSON.stringify($scope.list.appendixinfo),
                            alluser: $scope.data.contribution == 0,
                            tenantuser: false,
                            serviceid: 'notice',
                            method: $scope.status.noticeId == 0 ? 'saveNotice' : 'updateNotice',
                        };
                        if ($scope.status.noticeId != 0) {
                            params.noticeid = $scope.status.noticeId;
                        }
                        if (angular.isDefined($scope.list.userids) && $scope.list.userids.length > 0) {
                            params.userids = $scope.list.userids;
                        } else if (angular.isDefined($scope.list.groupids) && $scope.list.groupids.length > 0) {
                            params.groupids = $scope.list.groupids;
                        } else if (angular.isDefined($scope.list.newgroupids) && $scope.list.newgroupids.length > 0) {
                            params.newgroupids = $scope.list.newgroupids;
                        }
                        $scope.loadingPromise = iwoNoticeService.save(params).then((data) => {
                            if (data.issuccess == 'true') {
                                $state.params.noticeid = data.data.noticeid;
                                // $scope.cancel();
                                $state.transitionTo($state.current, $state.params, {
                                    reload: false,
                                });
                                defer.resolve(data.data.noticeid);
                            } else {
                                modalDialog.alertType('', data.msg, 'error', false);
                                defer.reject();
                            }
                        });
                    })
                    .error(function(msg) {
                        angular.invalidPosition($scope.noticeForm, $element);
                        defer.reject();
                    });
            });
            return defer.promise;
        }

        /**
         * [publish description]发布
         * @param  {[type]} noticeId [description] 公告ID
         * @return {[type]}          [description]
         */
        function publish(noticeId) {
            let defer = $q.defer();
            let params = {
                noticeids: noticeId,
                // token: $scope.status.token,
            };
            iwoNoticeService.publish(params).then((data) => {
                if (data.issuccess === 'true') {
                    defer.resolve(data.data.noticeid);
                } else if (data.msg === null) {
                    modalDialog.alertType('', data.data[0].msg, 'error', false);
                } else {
                    modalDialog.alertType('', data.msg, 'error', false);
                    defer.reject();
                }
            });
            return defer.promise;
        }

        /**
         * [theFormError description] 获取表单变化
         * @return {[type]} [description]
         */
        $scope.theFormError = function() {
            // 当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.noticeForm.$error) {
                errorArray.push(error);
            }
            $scope.status.noticeForm = $scope.status.noticeFormError == undefined ? [] : $scope.status.noticeFormError;
            if ($scope.status.noticeFormError.length != errorArray.length) {
                // 长度不相等说明表单errorname发生变化
                $scope.status.noticeFormError = errorArray;
            }
            return $scope.status.noticeFormError; // 返回
        };

        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [selectDistribution description] 选择发布范围
         * @return {[type]} [description]
         */
        $scope.selectDistribution = function() {
            iwoNoticeService.userAndDeptTransfer(
                '',
                function(result) {
                    $scope.data.publishDistributionType = result.selectedType;
                    if (result.selectedType == 0) {
                        $scope.data.selectedUsers = result.selectedArray;
                        $scope.selectedName = result.selectedArray
                            .map((_item) => _item.DESC)
                            .join('、');
                        $scope.data.selectedGroup = $scope.data.selectedDept = [];
                        $scope.list.userids = trsspliceString.spliceString($scope.data.selectedUsers, 'ID', ',');
                        if (angular.isDefined($scope.list.groupids)) {
                            delete $scope.list.groupids;
                        }
                        delete $scope.list.newgroupids;
                    } else if (result.selectedType == 1) {
                        $scope.data.selectedDept = result.selectedArray;
                        $scope.selectedName = result.selectedArray
                            .map((_item) => _item.GNAME)
                            .join('、');
                        $scope.data.selectedGroup = $scope.data.selectedUsers = [];
                        $scope.list.groupids = trsspliceString.spliceString($scope.data.selectedDept, 'GROUPID', ',');
                        if (angular.isDefined($scope.list.userids)) {
                            delete $scope.list.userids;
                        }
                        delete $scope.list.newgroupids;
                    } else {
                        $scope.data.selectedGroup = result.selectedArray;
                        $scope.selectedName = result.selectedArray
                            .map((_item) => _item.LABELNAME)
                            .join('、');
                        $scope.data.selectedDept = $scope.data.selectedUsers = [];
                        $scope.list.newgroupids = trsspliceString.spliceString($scope.data.selectedGroup, 'LABELORGANIZATIONID', ',');
                        if (angular.isDefined($scope.list.userids)) {
                            delete $scope.list.userids;
                        }
                        delete $scope.list.groupids;
                    }
                },
                $scope.data.publishDistributionType == 0
                    ? $scope.data.selectedUsers
                    : $scope.data.publishDistributionType == 2
                        ? $scope.data.selectedGroup
                        : $scope.data.selectedDept,
                $scope.data.publishDistributionType
            );
        };

        /**
         * [save description] 保存
         * @return {[type]} [description]
         */
        $scope.save = function() {
            save().then((data) => {
                modalDialog.alertType('', $scope.status.noticeId == 0 ? '新建公告成功' : '编辑公告成功', 'success', false, function() {
                    // $state.go('front.editctr.iWo.notice.manage', {}, { reload: 'front.editctr.iWo.notice.manage' });
                    $modalInstance.close({ newNotice: data });
                });
            });
        };

        /**
         * [saveAndPublish description] 发布并保存
         * @return {[type]} [description]
         */
        $scope.saveAndPublish = function() {
            save()
                .then((noticeId) => publish(noticeId))
                .then((id) => {
                    modalDialog.alertType('', '公告保存并发布成功', 'success', false, () => {
                        // $scope.cancel();
                        // $state.go('front.editctr.iWo.notice.manage', {}, { reload: 'front.editctr.iWo.notice.manage' });
                        // console.log(id);
                        $modalInstance.close({ newNoticeId: id });
                    });
                });
        };

        // /**
        //  * [cancel description] 取消/返回
        //  * @return {[type]} [description]
        //  */
        // $scope.cancel = function() {
        //     $state.go('front.editctr.iWo.notice', {}, { reload: false });
        // };

        /**
         * [selectedNoticeType description] 公告类型选择
         * @param  {[type]} type [description] 公告
         * @return {[type]}      [description]
         */
        $scope.selectedNoticeType = function(type) {
            $scope.list.typeid = type.typeid;
        };

        /**
         * [downloadFile description]  附件栏目，文件下载
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.downloadFile = function(item) {
            var $a = $(document.createElement('a'));
            $a.attr({
                href: item.SRCPICURL,
                download: item.APPDESC,
            });
            $a[0].click();
        };

        /**
         * [fileUploadSuccess 附件上传成功的回调]
         *
         * @param   {[type]}  resp  [resp description]
         * @param   {[type]}  file  [resp description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.fileUploadSuccess = function(resp, file) {
            if (resp.data.issuccess === 'false') {
                file.FILEINFO = '上传失败';
            } else {
                delete file.file;
                file.FILEINFO = '上传成功';
                file.FileDesc = resp.data.data.FileDesc;
                file.FileName = resp.data.data.FileName;
                file.FileSize = resp.data.data.FileSize;
            }
        };

        /**
         * [fileUploadFail 文件上传失败处理]
         *
         * @param   {[type]}  resp  [resp description]
         * @param   {[type]}  file  [file description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.fileUploadFail = function(resp, file) {
            if (resp.status === '413') {
                file.FILEINFO = '文件太大，不得大于' + $scope.appendixUpload.options.max + 'MB!';
            } else {
                file.FILEINFO = '未知错误!';
            }
        };

        /**
         * [fileUploadProgress 文件上传中]
         *
         * @param   {[type]}  evt   [evt description]
         * @param   {[type]}  file  [file description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.fileUploadProgress = function(evt, file) {
            file.FILEINFO = '上传中';
        };
    },
]);
